import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const IcareToolsPage = lazy(
  () => import("@/features/student-view/icare-tools/pages/icares-test-list")
);
const PassportPage = lazy(
  () => import("@/features/student-view/passport/pages/student-passport")
);
const GamesPage = lazy(
  () => import("@/features/student-view/games/pages/index")
);
const ComingSoonPage = lazy(() => import("@/features/coming-soon/page"));

// Ferrypedia routes
const FerrypediaPage = lazy(
  () => import("@/features/student-view/ferrypedia/pages/index")
);
const IndividualFeatherDetailsPage = lazy(
  () =>
    import(
      "@/features/student-view/ferrypedia/pages/individual-feather-details"
    )
);

// Folders routes
const FoldersPage = lazy(() => import("@/shared/folders/pages/folders-list"));

const TestResultsPage = lazy(
  () => import("@/shared/testResults/pages/test-results-page")
);

const OccupationAndEducationListPage = lazy(
  () => import("@/shared/testResults/pages/occupation-and-education-list")
);

const PreviewDiploma = lazy(
  () => import("@/features/student-view/passport/pages/preview-diploma")
);

export const otherRoutes: RouteObject[] = [
  {
    path: "/icares-tools",
    element: <IcareToolsPage />,
  },
  {
    path: "/passport",
    element: <PassportPage isAdmin={false} />,
  },
  {
    path: "/diploma/preview",
    element: <PreviewDiploma />,
  },
  {
    path: "/games",
    element: <GamesPage />,
  },
  {
    path: "/coming-soon",
    element: <ComingSoonPage />,
  },
  {
    path: "/ferrypedia",
    element: <FerrypediaPage />,
  },
  {
    path: "/ferrypedia/:categoryId",
    element: <IndividualFeatherDetailsPage />,
  },
  {
    path: "/folders",
    element: <FoldersPage isAdmin={false} />,
  },
  {
    path: "/test-results",
    element: <TestResultsPage />,
  },
  {
    path: "/occupation-and-education-lists",
    element: <OccupationAndEducationListPage />,
  },
];
